import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { playerSchema } from '../types';

export type CancelPromocodeMutationParams = {
	playerId: number;
};

export const createCancelPromocodeMutation = () =>
	createAuthMutation({
		params: declareParams<CancelPromocodeMutationParams>(),
		request: {
			method: 'PATCH',
			url: '/device/voucher/cancel',
			body: (data) => data,
		},
		response: {
			contract: zodContract(playerSchema),
		},
	});
